import { useQuery } from "@tanstack/react-query";
import useToken from "components/hooks/useToken";
import { solicitudes } from "api/solicitudes";

type DocumentType = "certificado" | "solicitud";

const fetchSolicitudDocumentPdfUrl = async (
  solicitudId: number,
  token: string,
  documentType: DocumentType
): Promise<string> => {
  const apiMethod =
    documentType === "certificado"
      ? solicitudes(token).getCertificadoAuditoriaPdf
      : solicitudes(token).getSolicitudFirmadaPdf;

  const { pdfUrl } = await apiMethod(solicitudId);

  if (pdfUrl) {
    return pdfUrl;
  } else {
    const docName =
      documentType === "certificado"
        ? "certificado de auditoría"
        : "solicitud firmada";
    throw new Error(`No se pudo descargar ${docName}!`);
  }
};

export const useSolicitudConsumoDocuments = (
  solicitudId: number | undefined,
  documentType: DocumentType,
  enabled: boolean
) => {
  const token = useToken();

  return useQuery(
    ["solicitudConsumoDocument", solicitudId, documentType],
    () => fetchSolicitudDocumentPdfUrl(solicitudId!, token, documentType),
    {
      enabled: enabled && !!solicitudId,
      retry: false,
      refetchOnWindowFocus: false,
      onError: (error) => {
        console.error(`Error fetching ${documentType} PDF URL:`, error);
      },
    }
  );
};
